import { useMemo } from 'react';

const useRemoteDataSelector = (f, parametersArray) => {
  const data = parametersArray.map(({ data: paramData }) => paramData);
  const loadingAnyData = parametersArray.some(({ loading }) => !!loading);

  const result = useMemo(() => {
    if (!loadingAnyData) {
      return f(...data);
    }
    return undefined;
  }, [...parametersArray, loadingAnyData]);

  const initialState = useMemo(() => f(...data), []);

  return [
    {
      data: result || initialState,
      loading: loadingAnyData,
      failed: parametersArray.some(({ failed }) => !!failed),
    },
  ];
};

export default useRemoteDataSelector;
